/**
 * Declare Variable
 */
const _reservationPageState = {
  selectedStatus: null,
  statusses: [],
  page: 1,
  itemsPerPage: 25,
  searchTerm: '',
  channelId: 0,
  locationId: 0,
  meetingtypeId: 0,
  useDateInput: true,
  startDate: new Date(),
  reachedEnd: false,
  reservations: [],
  endDate: new Date(),
}

const state = {
  reservation: null,

  reservationsPageState: { ..._reservationPageState },
};

const getters = {
  getReservation: (state) => state.reservation,
  getReservationsPageState: (state) => state.reservationsPageState,
};

const mutations = {
  /**
   * Set reservation in store
   */
  setReservation: (state, newState) => {
    state.reservation = newState;
  },

  /**
   * Set reservation page state in store
   */
  setReservationsPageState: (state, newState) => {
    state.reservationsPageState = newState;
  },
};

const actions = {};

/**
 * Export
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
